import { Pipe, PipeTransform } from '@angular/core';


export class ObjToArrayPipe implements PipeTransform {
	public transform(value: any, args?: any[]): any[] {
		let keyArr = Object.keys(value);
		let dataArr = [];
		keyArr.forEach((key) => {
			dataArr.push(value[key]);
		});
		return dataArr;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/pipes/object-to-array.pipe.ts